import { useRemoteRenderContext } from "../classes/contexts/RemoteRenderContext";

const useRemoteViewActions = (currentPlanId = null) => {
  const { client: remoteRendererClient } = useRemoteRenderContext();

  const getBrightnessAndContrast = async viewId => {
    if (remoteRendererClient) {
      try {
        return await remoteRendererClient.getBrightnessAndContrast(
          viewId,
          currentPlanId
        );
      } catch (error) {}
    }
  };

  const setBrightnessAndContrast = async (viewId, brightness, contrast) => {
    if (remoteRendererClient) {
      try {
        await remoteRendererClient.setBrightnessAndContrast(
          viewId,
          currentPlanId,
          brightness,
          contrast
        );
      } catch (error) {}
    }
  };

  const resetView = async viewId => {
    if (remoteRendererClient) {
      try {
        await remoteRendererClient.resetView(viewId, currentPlanId);
      } catch (error) {
        console.error("Error resetting view:", error);
      }
    }
  };

  const undoValidation = async (viewId = null) => {
    if (remoteRendererClient && currentPlanId) {
      try {
        const result = await remoteRendererClient.undoValidation(
          currentPlanId,
          viewId
        );
        return result;
      } catch (error) {
        throw error;
      }
    }
  };

  const redoValidation = async (viewId = null) => {
    if (remoteRendererClient && currentPlanId) {
      try {
        const result = await remoteRendererClient.redoValidation(
          currentPlanId,
          viewId
        );
        return result;
      } catch (error) {
        throw error;
      }
    }
  };

  const resetValidation = async () => {
    if (remoteRendererClient && currentPlanId) {
      try {
        const result = await remoteRendererClient.resetValidation(currentPlanId);
        return result;
      } catch (error) {
        throw error;
      }
    }
  };

  const getValidationHistoryState = async (viewId = null) => {
    if (remoteRendererClient && currentPlanId) {
      try {
        const result = await remoteRendererClient.getValidationHistoryState(
          currentPlanId,
          viewId
        );
        // Parse JSON string result if needed
        if (typeof result === "string") {
          return JSON.parse(result);
        }
        return result;
      } catch (error) {
        throw error;
      }
    }
  };

  return {
    getBrightnessAndContrast,
    setBrightnessAndContrast,
    resetView,
    undoValidation,
    redoValidation,
    resetValidation,
    getValidationHistoryState,
  };
};

export default useRemoteViewActions;
